// Gemeinsame Helfer für das Textsystem (Welle 90).
import { API_BASE } from "../../../api/config";

export const SCHREIBEN_API = `${API_BASE}/mietverwaltung/api/schreiben`;

export async function api(pfad, method = "GET", body) {
  const init = { method, headers: {} };
  if (body !== undefined) {
    init.headers["Content-Type"] = "application/json";
    init.body = JSON.stringify(body);
  }
  const res = await fetch(`${SCHREIBEN_API}${pfad}`, init);
  const ct = res.headers.get("content-type") || "";
  const data = ct.includes("application/json") ? await res.json() : await res.text();
  if (!res.ok) throw new Error((data && data.detail) || res.statusText);
  return data;
}

/* Download aus einer fetch-Response (Kopie des Musters aus Tab6Vorgaenge/SchreibenPanel —
   die Altstellen bleiben unangetastet, neue Komponenten nutzen diese Util). */
export async function blobDownload(res, fallback) {
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const m2 = cd.match(/filename\*=UTF-8''([^;]+)/);
  const m1 = cd.match(/filename="([^"]+)"/);
  const name = m2 ? decodeURIComponent(m2[1]) : (m1 ? m1[1] : fallback);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  return name;
}

export const STATUS_LABEL = {
  erfasst: "Erfasst", erzeugt: "PDF erzeugt", versendet: "Versendet — wartet auf Rückmeldung",
  rueckgemeldet: "Rückmeldung erhalten", abgeschlossen: "Abgeschlossen",
};
export const STATUS_CLS = {
  erfasst: "me-badge-warn", erzeugt: "me-badge-info", versendet: "me-badge-info",
  rueckgemeldet: "me-badge-ok", abgeschlossen: "me-badge-done",
};
